import React, { useEffect } from "react";
import Iframe from "react-iframe";
import CopyToClipboard from "../copytoclipboard/copytoclipboard.component";
import{ get } from 'global/lib/lodash';

import './ecs.css';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  chkimg: {
    width: "60%",
    float: "right",
    [theme.breakpoints.down('md')]: {
      width: "100%",
      float: "none"
    }
  }
}));

// ECS Wrapper Component
const Ecs = props => {
  const classes = useStyles();

  useEffect(() => {
    const checkChange = () => {
      if(window.innerHeight !== window.screen.height) { 
        setTimeout(() => {
          const elem = document.getElementById('ecs_container');
          elem.style = "";
        }, 200);
      }
    }

    const listener = document.addEventListener("fullscreenchange", checkChange);

    return () => {
      document.removeEventListener('fullscreenchange', listener);
    }
  }, []);

  const showsteptext = get(props, 'showStepText', false);

  const EcsData = props.data;

  let IframeUrl = props.param ? `${props.url}${props.param}` : `${props.url}`;

  const ecssteptext = EcsData.steps.map(stepDetail => {
    return (
      <li id={`step_${stepDetail.stepno}`} key={stepDetail.stepno.toString()}>
        {stepDetail.steptext}
      </li>
    );
  });

  const ecsstepcontrols = EcsData.steps.map(stepDetail => {
    return <li id={`btn-step_${stepDetail.stepno}`} key={stepDetail.stepno.toString()}></li>;
  });

  return (
    <React.Fragment>
      <div
        id="ecs_container"
        className={classes.chkimg}
      >
        <Iframe url={IframeUrl} id="ecs3d" title="Interactive 3D" allowFullScreen />
        <div id="steptext">
          <ol id="ecs_items">{ecssteptext}</ol>
        </div>
        <div id="fullscreen_controls">
          <a href="#" id="btn_fullscreen">
            <img id="btn-img_fullscreen" src="/ecs/asset/maximize.svg" />
          </a>
          <a href="#" id="btn_fullscreen-alt" style={{ display: "none" }}>
            <img id="btn-img_fullscreen-alt" src="/ecs/asset/maximize.svg" />
          </a>
        </div>
        <ul id="ecs_controls">
          <li id="btn_steps-expand">
            <a href="#" id="btn_steps-expand">
              <img src="/ecs/asset/chevron-down.svg" id="btn-img_steps-expand" />
            </a>
          </li>
          <li id="btn_camerareset">
            <a href="#">
              <img src="/ecs/asset/rotate-ccw.svg" id="btn-img_camerareset" />
            </a>
          </li>
          <li id="btn_play">
            <a href="#">
              <img src="/ecs/asset/play.svg" id="btn-img_play" />
            </a>
          </li>
          <li id="btn_cutaway">
            <a href="#">
              <img src="/ecs/asset/cutaway.svg" id="btn-img_cutaway" />
            </a>
          </li>
          <li id="btn_help">
            <a href="#">
              <img src="/ecs/asset/help-circle.svg" id="btn-img_help" />
            </a>
          </li>
          {/* <li id="btn_share">
            <a href="#">
              <img src="/ecs/asset/share-2.svg" id="btn-img_share" />
            </a>
          </li> */}
        </ul>
        <ol id="ecs_stepcontrols">{ecsstepcontrols}</ol>
        <div id="ecs_help">
          <p>Help content (navigation gestures, button labels, 'report an issue' link)</p>
        </div>
        <div id="ecs_share">
          <CopyToClipboard />
        </div>
        {/* <Card>
          <CardContent>
            <Typography>link here...</Typography>
          </CardContent>
          <CardActions>
            <Button>Copy</Button>
          </CardActions>
        </Card> */}
      </div>
      {showsteptext && <ol>{ecssteptext}</ol>}
    </React.Fragment>
  );
};

export default Ecs;
